export const getLoginUrl=(route)=>{
    // let originUrl = process.env.NEXT_PUBLIC_WEBSITE_URL+route;
    let base64Domain = "aHR0cHM6Ly93d3cubmV3c3Rhay5pbg==";
    let url = process.env.NEXT_PUBLIC_SSO_DOMAIN + "/saml_login/other/"+ ( route ? Buffer.from(route).toString('base64') : base64Domain );
    return url;
}

export const getLogoutUrl=(route)=>{
    // let baseUrl = process.env.NEXT_PUBLIC_WEBSITE_URL;
    // let logoutUrl = baseUrl+route;
    let logoutUrl = Buffer.from(route).toString('base64');
    let url = process.env.NEXT_PUBLIC_SSO_DOMAIN+'/saml_logout?ReturnTo='+logoutUrl;
    return url;
}

export const getDashboardUrl=(route)=>{
    let originUrl = process.env.NEXT_PUBLIC_WEBSITE_URL+route;
    let base64Domain = "aHR0cHM6Ly93d3cubmV3c3Rhay5pbg==";
    let url = process.env.NEXT_PUBLIC_SSO_DOMAIN + "/dashboard/activity?site="+ ( originUrl ? Buffer.from(originUrl).toString('base64') : base64Domain );
    return url;
}